import { styled } from '@mui/material';

interface StyledRowProps {
    marginBottom: string;
}

const StyledRow = styled('div')<StyledRowProps>(({ marginBottom }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: marginBottom || '1.875rem'
}));

export default StyledRow;
